module.exports = __webpack_public_path__ + "img/mogrige.c901503f.png";